import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/Industries-we-serve-light.svg")